import { render } from "./CustomLabelRadio.vue?vue&type=template&id=5ff9b336"
import script from "./CustomLabelRadio.vue?vue&type=script&lang=js"
export * from "./CustomLabelRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__